import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer from '../reducers'
import rootSaga from '../sagas'
import history from '../history'

const sagaMiddleware = createSagaMiddleware()

const configureStore = (initialState = {}) => {
	const composeEnhancers =
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

	const store = {
		...createStore(
			rootReducer,
			initialState,
			composeEnhancers(
				applyMiddleware(...routerMiddleware(history), sagaMiddleware)
			)
		),
		runSaga: sagaMiddleware.run(rootSaga)
	}
	return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/index.js